import { IProjectsResponseDto } from "@kuika/kuika-cl-model/src/dtos/projects-response";
import * as React from "react";
import { KIcon } from "../../../../shared/icon/k-icon";
import ProjectIcon from "../../../../svgs/small-icons/project-icon.svg";
import "./project-app-icon.scss";

export type ProjectAppIconProject = Pick<
  IProjectsResponseDto,
  "iconAsImage" | "iconName" | "iconColor" | "iconBackgroundColor"
>;

export interface IProjectAppIconProps {
  project: ProjectAppIconProject;
  /** The tile's edge in px: 24 in the Apps table, 20 in the header's app switcher. */
  size?: number;
}

/**
 * An app's identity tile — its uploaded image, else its picked glyph on its picked colour, else
 * the generic app mark. The Apps table and the header's app switcher both draw it, so an app
 * reads the same wherever it is listed. The colours are the user's own choice, stored on the
 * project, which is why they are inline rather than tokens.
 */
export const ProjectAppIcon = ({ project, size = 24 }: IProjectAppIconProps): React.ReactElement => {
  const box: React.CSSProperties = { width: size, height: size };
  if (project.iconAsImage) {
    return <img src={project.iconAsImage} alt="" className="kuika-project-app-icon" style={box} />;
  }
  if (project.iconName) {
    return (
      <span className="kuika-project-app-icon" style={{ ...box, backgroundColor: project.iconBackgroundColor }}>
        <KIcon iconName={project.iconName} style={{ color: project.iconColor, fontSize: Math.round(size * 0.66) }} />
      </span>
    );
  }
  return (
    <span className="kuika-project-app-icon kuika-project-app-icon--fallback" style={box}>
      <ProjectIcon width={size} height={size} />
    </span>
  );
};
